import React from 'react';
import { injectIntl } from "react-intl";
import './style.scss';

function ConfirmDialog({ intl: { messages }, show, onConfirm, onCancel, content, icon, cancelBtn, confirmBtn }) {
    return (
        <div className={`confirm-modal-container ${show ? ' show' : ''}`}>
            <div className="confirm-modal">
                {
                    icon && (
                        <img src={icon} alt="checkIcon" className="confirm-modal_icon" />
                    )
                }
                <h4>{content}</h4>
                <div className="confirm-modal_buttons" style={ icon && {justifyContent: 'center'} }>
                    <button className="cancel_btn" 
                        onClick={(e) => {
                        e.preventDefault();
                        onCancel()
                        }}>{cancelBtn}</button>
                    <button onClick={(e) => {
                        e.preventDefault();
                        onConfirm();
                        }}>{confirmBtn}</button>
                </div>
            </div>
        </div>
    )
}

export default injectIntl(ConfirmDialog)
